export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const nameRegex = /^(?=.{2,}$)[A-Za-z0-9]+(?:[ '-][A-Za-z0-9]+)*$/;
// export const projectNameRegex = /^(?=.{1,}$)[A-Za-z0-9]+(?:[ '_-][A-Za-z0-9]+)*$/;
export const projectNameRegex = /^[^<>]+$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
